import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Loader } from 'oxyrion-ui/lib';
import { LoaderWrapper } from '../ReusableComponents';
import { __, getColorByReceivablesGroup } from '../../Utils';
import { rem } from 'polished';
import C3Chart from 'react-c3js';
import 'c3/c3.css';
import { connect } from '../../Store';

const StyledChart = styled(C3Chart)``;

const Wrapper = styled.div`
  min-width: 600px;
  ${({ theme }) => theme.media.m`
  padding-right: ${rem(50)};
`};
`;

const Header = styled.div`
  font-family: 'Open Sans';
  font-weight: 100;
  font-size: ${rem(30)};
  margin-bottom: ${rem(22)};
`;

class BrandsGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartData: {
        columns: [],
        type: 'donut',
        color: (color, d) => {
          return getColorByReceivablesGroup(d);
        },
      },
      donut: {
        title: __(''),
        width: 70,
      },
    };
  }

  componentWillReceiveProps(nextProps) {
    const { chartData } = this.state;
    if (nextProps.data !== this.props.data) {
      chartData.columns = nextProps.data;
      // chartData.colors = nextProps.colors;

      this.setState({
        chartData,
      });
    }
  }

  render() {
    const { loading, header } = this.props;

    if (loading)
      return (
        <LoaderWrapper style={{ width: '100%' }}>
          <Loader size="xl" />
        </LoaderWrapper>
      );

    return (
      <React.Fragment>
        {header && <Header>{header}</Header>}
        <Wrapper>
          <StyledChart
            //   unloadBeforeLoad
            data={this.state.chartData}
            donut={this.state.donut}
            legend={{
              show: false,
            }}
            size={{
              height: 400,
            }}
          />
        </Wrapper>
      </React.Fragment>
    );
  }
}

BrandsGraph.propTypes = {
  data: PropTypes.arrayOf(PropTypes.arrayOf()),
  header: PropTypes.string,
  loading: PropTypes.loading,
};

BrandsGraph.defaultProps = {
  data: [],
  header: undefined,
  loading: false,
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(BrandsGraph);



// WEBPACK FOOTER //
// ./src/Components/ReceivablesGraph/index.jsx